<script>
import WidgetCard from '@widgets/widget-card.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    WidgetCard,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
    },
    sheetClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      header: [
        {
          text: this.$t('lineup.line_up_header'),
          value: 'lineup',
          width: '100px',
        },
        {
          text: this.$t('lineup.index'),
          value: 'index',
          width: '80px',
          class: this.$style.indexClass,
        },
        {
          text: this.$t('lineup.appearance'),
          value: 'appearance',
          align: 'end',
          width: '120px',
        },
      ],
      lineUps: [],
    }
  },
  created() {
    this.getPlayerStatData({ id: this.playerId }).then((response) => {
      if (typeof response.line_up === 'undefined') {
        console.error("Couldn't load player Stat data", response)
      } else {
        const data = response.line_up
        // map as array
        this.lineUps = Object.keys(data).map((key) => ({
          lineup: key,
          index: data[key].performance.toFixed(2),
          appearance: data[key].appearances,
        }))
        this.loaded = true
        this.$emit('loaded', this.loaded)
      }
    })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    itemClass(item) {
      return [item.lineup === this.$t('lineup.total') ? this.$style.footer : '']
    },
  },
}
</script>

<template>
  <WidgetCard :title="$t('lineup.title')" :sheet-class="sheetClass">
    <v-data-table
      dense
      class="v-data-table--font-xs"
      :headers="header"
      :items="lineUps"
      :item-class="itemClass"
      :hide-default-footer="true"
    >
      <template slot="item.index" slot-scope="item">
        <td :class="['text-start', $style.indexClass]">{{ item.value }}</td>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.tableLine {
  line-height: 1rem;
}

.indexClass {
  color: $color-accent;
}

.footer {
  font-weight: bold;
  border-top: 1px solid black !important;
}
</style>
